<template>
  <div id="uld-invoice">
    <el-row class="mb-1">
      <el-col :span="24" :sm="12">
        <h3>Repair - ULD Invoice</h3>
      </el-col>
      <el-col :span="24" :sm="12">
        <div class="text-right">
          <el-button type="primary" @click.prevent="viewForm"
            >Create Invoice</el-button
          >
          <el-button type="primary" @click="openFilter">Filter</el-button>
        </div>
        <app-dialog ref="filterDialog">
          <el-form
            :model="filter"
            label-position="left"
            label-width="25%"
            :rules="filter.rules"
            ref="filterForm"
          >
            <el-form-item label="Date Range" prop="dateFilter">
              <el-date-picker
                v-model="filter.dateFilter"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                unlink-panels
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Customer/Airline" prop="customer_id">
              <el-select v-model="filter.customer_id" clearable filterable>
                <el-option
                  v-for="d in customers"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:footer>
            <div>
              <el-button type="primary" @click="getReport"
                >Submit Filter</el-button
              >
            </div>
          </template>
        </app-dialog>
        <invoice-form @refreshList="getReport" ref="invoiceForm"></invoice-form>
      </el-col>
    </el-row>
    <div class="bg-white" label-position="top" v-loading="isLoading">
      <el-row>
        <el-col>
          <el-table
            ref="invoiceTable"
            :data="data.data"
            empty-text="Input the date filter to fetch data"
            max-height="800"
          >
            <!-- <el-table-column fixed type="selection" width="55">
            </el-table-column> -->
            <el-table-column fixed width="120" label="Invoice No.">
              <template slot-scope="scope">
                <a
                  href="#"
                  @click.prevent="download_per_invoice(scope.row.id)"
                  type="text"
                  size="small"
                >
                  {{ scope.row.invoice_no }}
                </a>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              label="Invoice Date"
              prop="invoice.date"
            >
              <template slot-scope="scope">
                {{ scope.row.invoice_date | dateFormat("M/D/YYYY") }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              fixed
              width="120"
              label="Job Order No."
              prop="job_order_number"
            >
            </el-table-column> -->

            <!-- <el-table-column
              min-width="140"
              label="ULD ID Code"
              prop="masterlist.uld_id_code"
            >
            </el-table-column> -->
            <!-- <el-table-column
              width="120"
              label="ULD Part No."
              prop="masterlist.part"
            >
            </el-table-column> -->
            <!-- <el-table-column
              width="120"
              label="Manufacturer"
              prop="masterlist.manufacturer"
            >
            </el-table-column> -->

            <!-- <el-table-column
              width="200"
              label="Description"
              prop="masterlist.description"
            >
            </el-table-column> -->
            <el-table-column min-width="120" label="Owner" prop="customer_name">
            </el-table-column>
            <!-- <el-table-column
              width="120"
              label="Date Received"
              prop="date_received"
            >
              <template slot-scope="scope">
                {{ scope.row.date_received | dateFormat("M/D/YYYY") }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              width="120"
              label="Collected From"
              prop="collected_from"
            >
            </el-table-column> -->
            <!-- <el-table-column width="100" label="Delivery Date" prop="">
              <template slot-scope="scope">
                {{
                  scope.row.uld_out
                    ? scope.row.uld_out.delivery_date
                    : "" | dateFormat
                }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column width="100" label="Delivery No." prop="">
              <template slot-scope="scope">
                {{ scope.row.uld_out ? scope.row.uld_out.delivery_num : "" }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column width="100" label="Status" prop="status.name">
        </el-table-column> -->
            <!-- <el-table-column width="100" label="RepDate" prop=""> </el-table-column> -->
            <!-- <el-table-column width="100" label="InvNum" prop=""> </el-table-column> -->
            <!-- <el-table-column width="100" label="InvDate" prop=""> </el-table-column> -->
            <!-- <el-table-column
          width="100"
          label="SerNum"
          prop="masterlist.tso_serial_no"
        >
        </el-table-column> -->
            <!-- <el-table-column width="100" label="Labor" prop="labor">
            </el-table-column>
            <el-table-column width="100" label="Materials" prop="materials">
            </el-table-column>
            <el-table-column width="100" label="Cleaning" prop="cleaning_cost">
            </el-table-column>
            <el-table-column width="120" label="Remarks" prop="remarks">
            </el-table-column> -->
          </el-table>
        </el-col>
      </el-row>
      <el-row :gutters="15" type="flex" align="middle">
        <el-col :sm="12">
          <el-pagination
            v-show="!isLoading"
            class="pt-1 pb-1"
            background
            layout="prev, pager, next"
            :total="data.paging.total"
            :page-size="pager.limit"
            :current-page="parseInt(data.paging.cur_page)"
            @current-change="getReport"
          ></el-pagination>
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-button
            class="mr-1"
            type="primary"
            size="small"
            @click="download"
            :disabled="invoiceSelection.length == 0"
            >Download Report</el-button
          >
          <!-- <app-dialog ref="downloadFilterDialog">
            <el-form
              :model="downloadFilter"
              label-position="left"
              label-width="25%"
              ref="downloadFilterForm"
            >
              <el-form-item label="Date Range" prop="dateFilter">
                <el-date-picker
                  v-model="downloadFilter.dateFilter"
                  type="daterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  unlink-panels
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="Customer/Airline" prop="customer_id">
                <el-select
                  v-model="downloadFilter.customer_id"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="d in customers"
                    :value="d.value"
                    :key="d.value"
                    :label="d.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <template v-slot:footer>
              <div>
                <el-button type="primary" @click="download"
                  >Download Report</el-button
                >
              </div>
            </template>
          </app-dialog> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";
import ULD from "@/models/ULD";
import invoiceForm from "./invoice.vue";
export default {
  name: "InvoiceList",
  components: { invoiceForm },
  data: () => ({
    filter: {
      dateFilter: [],
      customer_id: "",
      rules: {
        customer_id: [{ required: true, message: "Customer is required" }],
        dateFilter: [
          { required: true, message: "Date Range filter is required" }
        ]
      }
    },
    downloadFilter: {
      dateFilter: [],
      customer_id: ""
    },
    isLoading: false,
    data: { data: [], paging: {} },
    customers: [],
    customers_data: [],
    pager: {
      limit: 25
    },
    invoiceSelection: []
  }),

  methods: {
    updateSelection() {
      this.invoiceSelection = this.$refs.invoiceTable.selection.map(o => o.id);
    },
    openFilter() {
      this.$refs.filterDialog.open();
    },
    getCustomer(customer) {
      let c = this.customers.find(o => o.value == customer);
      if (c) return c.text;
      else "";
    },
    getReport() {
      if (!this.$refs.filterForm) return;

      this.$refs.filterForm.validate(valid => {
        if (!valid) return;

        this.$refs.filterDialog.close();

        this.isLoading = true;
        let params = {
          generated_invoice: 1,
          is_invoice_view: 1,
          limit: 2000
        };

        if (this.filter.dateFilter[0] && this.filter.dateFilter[0] != "") {
          params.datefrom = moment(this.filter.dateFilter[0]).format(
            "YYYY-MM-DD"
          );
          params.dateto = moment(this.filter.dateFilter[1]).format(
            "YYYY-MM-DD"
          );
        }

        if (this.filter.customer_id) {
          params.customer_id = this.filter.customer_id;
        }

        ULD.list(params).then(resp => {
          this.isLoading = false;
          this.data = resp;
          this.$refs.invoiceTable.toggleAllSelection();
        });
      });
    },
    viewForm() {
      this.$refs.invoiceForm.open();
    },
    // viewDownloadFilter() {
    //   this.$refs.downloadFilterDialog.open();
    // },
    download() {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `ULD Invoice Report ${d}`,
        ext: ".csv"
      };
      this.isLoading = true;
      let report_url = "/api/v1/repair/uld";

      let params = ["is_invoice=1", "is_invoice_report=1"];
      // if (
      //   this.downloadFilter.dateFilter[0] &&
      //   this.downloadFilter.dateFilter[0] != ""
      // ) {
      //   params.push(
      //     `datefrom=${moment(this.downloadFilter.dateFilter[0]).format(
      //       "YYYY-MM-DD"
      //     )}`
      //   );
      //   params.push(
      //     `dateto=${moment(this.downloadFilter.dateFilter[1]).format(
      //       "YYYY-MM-DD"
      //     )}`
      //   );
      // }

      // if (this.downloadFilter.customer_id) {
      //   params.push(`customer_id=${this.downloadFilter.customer_id}`);
      // }

      if (this.invoiceSelection.length != 0) {
        params.push(`uldin_ids=${this.invoiceSelection.toString()}`);
        api
          .download(`${report_url}/?${params.join("&")}`, reportInfo)
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    download_per_invoice(id) {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `ULD Invoice Report ${d}`,
        ext: ".csv"
      };
      this.isLoading = true;
      let report_url = "/api/v1/repair/uld";

      let params = ["is_invoice=1", "is_invoice_report=1"];
      params.push(`invoice_id=${id}`);
      api
        .download(`${report_url}/?${params.join("&")}`, reportInfo)
        .then(() => {
          this.isLoading = false;
        });
    },
    customer_list() {
      ULD.customers_data().then(resp => {
        this.customers = resp;
      });
    }
  },

  mounted() {
    this.getReport();
    this.customer_list();
  }
};
</script>

<style lang="scss" scoped></style>
